var map = {
	"./decidim/avatar-multiuser.png": 79497,
	"./decidim/brands/facebook.svg": 12285,
	"./decidim/brands/google.svg": 49444,
	"./decidim/brands/twitter-x.svg": 40065,
	"./decidim/cc-badge.png": 92255,
	"./decidim/decidim-logo.svg": 63176,
	"./decidim/default-avatar.svg": 69695,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 62885,
	"./decidim/icons.svg": 86302,
	"./decidim/pattern.png": 5101,
	"./decidim/placeholder-card-g.svg": 17666,
	"./decidim/placeholder-card-l.svg": 69321,
	"./decidim/placeholder.jpg": 27640,
	"./decidim/remixicon.symbol.svg": 40058,
	"./decidim/vendor/social-share-button/douban.svg": 25981,
	"./decidim/vendor/social-share-button/email.svg": 37470,
	"./decidim/vendor/social-share-button/facebook.svg": 4086,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 60378,
	"./decidim/vendor/social-share-button/hacker_news.svg": 66926,
	"./decidim/vendor/social-share-button/linkedin.svg": 64212,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 68173,
	"./decidim/vendor/social-share-button/pinterest.svg": 21800,
	"./decidim/vendor/social-share-button/reddit.svg": 96610,
	"./decidim/vendor/social-share-button/telegram.svg": 32771,
	"./decidim/vendor/social-share-button/tumblr.svg": 68224,
	"./decidim/vendor/social-share-button/twitter.svg": 16323,
	"./decidim/vendor/social-share-button/vkontakte.svg": 72393,
	"./decidim/vendor/social-share-button/wechat.svg": 86044,
	"./decidim/vendor/social-share-button/whatsapp.svg": 88340,
	"./decidim/vendor/social-share-button/x.svg": 29798,
	"./decidim/vendor/social-share-button/xing.svg": 91282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34398;